module.exports = __webpack_public_path__ + "be3c1ce46e0607b788620e34f126c685.png";